import React from 'react';
import { Typography } from '@mui/material';

import styles from './PressureCell.module.scss';

type Props = {
  loading: boolean;
  pressure?: number | null;
  units: string | undefined;
};

const PressureCell: React.FC<Props> = ({ pressure, loading, units = 'MB' }) => {
  const loadingOrError = (!pressure && pressure !== 0) || loading;

  return (
    <div className={styles.wrapper} data-testid="forecast-table-pressure-cell">
      {loadingOrError ? (
        <div data-testid="forecast-table-pressure-empty-content" className={styles.emptyContent}>
          <Typography
            className={styles.units}
            color="text.light"
            component="p"
            data-testid="forecast-table-pressure-units-empty"
            variant="caption2"
          >
            --mb
          </Typography>
        </div>
      ) : (
        <Typography
          className={styles.content}
          component="span"
          data-testid="forecast-table-pressure-content"
        >
          <Typography
            className={styles.pressure}
            color="text.primary"
            component="h3"
            data-testid="forecast-table-pressure"
            variant="subHeadline"
          >
            {pressure}
          </Typography>
          <Typography
            className={styles.units}
            color="text.primary"
            component="p"
            data-testid="forecast-table-pressure-units"
            variant="caption1"
          >
            {units?.toLowerCase()}
          </Typography>
        </Typography>
      )}
    </div>
  );
};

export default PressureCell;
